import { Grid } from '@material-ui/core';
import SocialIntro from 'components/pages/Qemotion/IntroBlock/SocialIntro';
import React from 'react';
import styled from 'styled-components';
import { breakpoint } from 'utils/mediaQueries';
import Typography from '@material-ui/core/Typography';

const SocialGrid = styled(Grid)`
  height: 100%;
  padding: 0.5rem;
  ${breakpoint.down('md')`
  justify-content: flex-start; height: auto`};
`;
const LifeDescription = styled(Typography)`
  text-align: ${props => props.textalign};
  padding: 1rem;
  line-height: 1.5rem;
  margin-top: -3.2rem;
  ${breakpoint.down('md')`
  margin-top: 0; text-align:left;padding: 0.5rem`};
`;

const BlockLifeSocial = ({ data, order }) => {
  return (
    <Grid
      container
      justify={'center'}
      direction={order === 'even' ? 'row' : 'row-reverse'}
    >
      <Grid container item xs={10} sm={10} md={6} lg={5}>
        <LifeDescription
          variant={'body2'}
          textalign={order === 'even' ? 'right' : 'left'}
        >
          {data.rawMarkdownBody}
        </LifeDescription>
      </Grid>
      <SocialGrid
        container
        justify={'flex-start'}
        item
        xs={10}
        sm={10}
        md={6}
        lg={5}
      >
        <SocialIntro
          role={'ceo'}
          color={'purple'}
          directionposition={order === 'even' ? 'row-reverse' : 'row'}
          data={data.frontmatter.socialNetwork}
        />
      </SocialGrid>
    </Grid>
  );
};
export default BlockLifeSocial;
